import styled from "styled-components";
import { Icon } from "../../../util";

export const PlusIcon = styled(Icon)`
  margin-left: 8px;
`;
